/* global d3, $, topojson */

// FOR EDITING CENTROIDS OF COUNTRIES
// circleNodes = d3.select(".global-map__map").selectAll('circle').nodes()
// circleNodes.map(function(n) {
//   current = d3.select(n)
//   x = current.attr('cx')
//   y = current.attr('cy')
//   id = current.attr('data-id')
//   coords = foo.invert([x,y])
//   return `${coords[0]},${coords[1]},${id}`
// })
import FuzzySet from '../../../../node_modules/fuzzyset.js';

// Polyfill for IE9
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector
                              || Element.prototype.webkitMatchesSelector;
}

function renderMap() {
  if (document.querySelector('.global-map__map') == null) {
    return;
  }
  const height = 630;
  const width = height * 2.177;
  let world;
  let countryData;
  let customCentroids;
  let ie = false;
  const svg = d3.select('.global-map__map .map-wrap')
    .select('svg')
      .attr('viewBox', '0 0 ' + width + ' ' + height)

  if (svg.node().clientHeight == 150) {
    // We are dealing with IE, so disable zoom.
    ie = true;
    svg.attr('width', width).attr('height', height)
    d3.select('.map-wrap').style('width', d => `${width}px`).style('margin', '0 auto').style('position', 'relative')
    d3.select('.global-map__caption').text('Click a country to see the solutions offered in that country.')
    d3.select('.global-map__search').style('display', 'none')
  }

  let xAxis = d3.scaleLinear().domain([0, 1]).range([0, width])
  let yAxis = d3.scaleLinear().domain([0, 1]).range([0, height])

  // Gives the user something to drag if don't click on land.
  const backdrop = svg.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', width)
      .attr('height', height)
      .attr('fill', '#f5f5f5');


  const g = svg.append('g');

  // An overlay to transform without messing up the viz proper
  const zoomRect = svg.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', width)
      .attr('height', height)
      // .attr('fill', '#f5f5f5')
      .style('fill', 'none')
      .style('pointer-events', d => ie ? 'none' : 'all');


  // potentialProjections = [d3.geoEckert3(), d3.geoGinzburg4(), d3.geoAugust(),
  // d3.geoOrthographic(), d3.geoAzimuthalEquidistant(), d3.geoEquirectangular(),
  // d3.geoNaturalEarth1()]

  const projection = d3.geoRobinson()
    .scale(240)
    .center([15, 10])
    .translate([width / 2, height / 2]);




  function zoomed() {
    emptySearchBox();
    let {k, x, y} = d3.event.transform;
    g.attr('transform', d3.event.transform)
    g.selectAll('path')
        .attr('stroke-width', 1.2 / k)
    positionTooltip();
  }

  const zoom = d3.zoom()
      .extent([[0, 0], [width, height]])
      .scaleExtent([1, 16])
      .translateExtent([
        [-(width * 0.1), -(height * 0.1)],
        [width * 1.1, height * 1.1]
      ])

  zoomRect.call(zoom.on('zoom', zoomed));

  const path = d3.geoPath()
      .projection(projection);

  const recognizedRegions = ['Americas', 'Asia-Pacific', 'Europe', 'Africa and the Middle East'];
  const blue = '#00b5f0';
  const green = '#8bc348';
  const orange = '#f37521';
  const purple = '#7b0c72';
  const palette = [blue, purple, green, orange];
  const colors = d3.scaleOrdinal().domain(recognizedRegions).range(palette);

  const tooltip = d3.select('.global-map-tooltip-js');
  const tooltipCountryName = tooltip.select('.global-map-tooltip-country-name-js');
  const placard = tooltip.select('.tooltip-placard-js');


  // START DROP SHADOW
  // filters go in defs element
  const defs = svg.append('defs');

  let newDrop = defs.append('filter')
      .attr('id', 'drop-shadow')
      .attr('height', '400%')
      .attr('width', '400%');

  newDrop.append('feDropShadow')
      .attr('dx', 5)
      .attr('dy', 5)
      .attr('stdDeviation', 5)

  // create filter with id #drop-shadow
  // height=130% so that the shadow is not clipped
  const filter = defs.append('filter')
      .attr('id', 'drop-shadow--original')
      .attr('height', '200%')
      .attr('width', '200%');

  // SourceAlpha refers to opacity of graphic that this filter will be applied to
  // convolve that with a Gaussian with standard deviation 3 and store result
  // in blur
  filter.append('feGaussianBlur')
      .attr('in', 'SourceAlpha')
      .attr('stdDeviation', 5)
      .attr('result', 'blur');

  // translate output of Gaussian blur to the right and downwards with 2px
  // store result in offsetBlur
  filter.append('feOffset')
      .attr('in', 'blur')
      .attr('dx', 5)
      .attr('dy', 5)
      .attr('result', 'offsetBlur');

  // overlay original SourceGraphic over translated blurred opacity by using
  // feMerge filter. Order of specifying inputs is important!
  const feMerge = filter.append('feMerge');

  feMerge.append('feMergeNode')
      .attr('in', 'offsetBlur');
  feMerge.append('feMergeNode')
      .attr('in', 'SourceGraphic');
  // END DROP SHADOW

  d3.json('/assets/data/sedgwick-world.json').then((world) => {
    const countryFeatures = topojson.feature(world, world.objects.countries).features;

    // // Equip countries with their custom centroids
    // countryFeatures.map((x) => {
    //   let customCentroid = customCentroids.find(y => y.id === x.id);
    //   if (customCentroid !== undefined) {
    //     x.properties.centroid = {
    //       lat: +customCentroid.lat,
    //       long: +customCentroid.long,
    //     };
    //     return x;
    //   } else {
    //     x.properties.centroid = {
    //       lat: 0,
    //       long: 0,
    //     };
    //   }
    // });

    // let countries = g.append("path")
    //     // .data(countryFeatures)
    //     .datum(countryFeatureCollection)
    //       .attr('d', path)
    //       .attr('fill', '#d8d8d8')
    //       .attr('stroke', 'white')

    const countries = g.selectAll('.map__country')
        .data(countryFeatures)
      .enter().append('path')
        .attr('class', 'map__country')
        .attr('d', path)
        .attr('data-name', d => d.properties.NAME_LONG)
        .attr('fill', function(d) {
          let attributes = d.properties;
          let matchedEntry = entries.filter(x => attributes.ISO_A2.toLowerCase() === x.code);
          if (recognizedRegions.includes(attributes.REGION_UN) && matchedEntry.length > 0) {
            d3.select(this).classed('country--active', true)
            return colors(attributes.REGION_UN)
          } else {
            return '#d8d8d8';
          }
        })
        // .attr('fill', function(d) {
        //   let attributes = countryData.find(x => d.id === x.ISO_N3.padStart(3, 0));
        //   if (attributes !== undefined) {
        //     let matchedEntry = entries.filter(x => attributes.ISO_A2.toLowerCase() === x.code);
        //     if (recognizedRegions.includes(attributes.REGION_UN) && matchedEntry.length > 0) {
        //       d3.select(this).classed('country--active', true)
        //       return colors(attributes.REGION_UN)
        //     } else {
        //       return '#d8d8d8';
        //     }
        //   } else {
        //     return '#d8d8d8';
        //   }
        // })
        .attr('stroke', 'white')
        .attr('data-id', d => d.id);

    let missingNations = [
        {
         properties: {
           'NAME_LONG': 'Faroe Islands',
           'REGION_UN': 'Europe',
           'ISO_A2': 'FO',
           id: '234',
           LAT: 62.163594,
           LONG: -7.002323
         }
        },
        {
         properties: {
           'NAME_LONG': 'Dutch Caribbean',
           'REGION_UN': 'Americas',
           'ISO_A2': 'AN',
           LAT: 13.306,
           LONG: -68.731
         }
        },
       // {
       //  'NAME_LONG': 'Hong Kong',
       //  'REGION_UN': 'Asia-Pacific',
       //  id: '344',
       //  properties: {
       //   centroid: {
       //     lat: 22.3964,
       //     long: 114.1095
       //   }
       //  }
       // },
       // { 
       //  'NAME_LONG': 'Bahrain',
       //  'REGION_UN': 'Africa and the Middle East',
       //  id: '048',
       //  properties: {
       //    centroid: {
       //      lat: 26.0667,
       //      long: 50.5577
       //    }
       //  }
       // },
       // {
       //  'NAME_LONG': 'Singapore',
       //  'REGION_UN': 'Asia-Pacific',
       //  id: '702',
       //  properties: {
       //    centroid: {
       //      lat: 1.3521,
       //      long: 103.8198
       //    }
       //  }
       // },
       // {
       //  'NAME_LONG': 'Guam',
       //  'REGION_UN': 'Asia-Pacific',
       //  id: '316',
       //  properties: {
       //    centroid: {
       //      lat: 13.4443,
       //      long: 144.7937
       //    }
       //  }
       // }
    ];

    let missingDots = g.selectAll('.missing-nations')
        .data(missingNations)
      .enter().append('circle')
        
    missingDots.attr('class', 'country--active map__country')
    missingDots.attr('cx', d => {
          const centroid = projection([d.properties.LONG, d.properties.LAT]);
          return centroid[0];
        })
        .attr('cy', d => {
          const centroid = projection([d.properties.LONG, d.properties.LAT]);
          return centroid[1];
        })
        .attr('r', 5)
        .attr('fill', d => colors(d.properties.REGION_UN));
    
    // const centroids = countryFeatures.map(function(x) {
    //   let name = countryIndex.find(y => y.key == x.id);
    //   if (name == undefined) {
    //     // console.info(x)
    //   } else {
    //     name = name.values[0]['NAME_LONG'] 
    //   }
    //   let attrs = { id: x.id, name: name, centroid: path.centroid(x)}
    //   return attrs
    // });

    // SEE WHICH COUNTRIES ARE NOT REPRESENTED IN THE GEOMETRY DATA
    // console.info(countryData.filter(x => countryFeatures.map(y => y.id).indexOf(x["ISO_N3"].padStart(3,0)) == -1))

    // g.selectAll(".country-labels").data(centroids).enter().append("text")
    //     .attr('x', d => d.centroid[0])
    //     .attr('y', d => d.centroid[1])
    //     .attr("text-anchor", "middle")
    //     .text(d => d.name)


    // // START EDITING CENTROIDS
    // let dots = g.selectAll('.centroids').data(centroids)
    //   .enter().append('circle')
    //     .attr('cx', d => d.centroid[0])
    //     .attr('cy', d => d.centroid[1])
    //     .attr('fill', 'magenta')
    //     .attr('r', 5)
    //     .attr('data-id', d => d.id)

    // let drag_handler = d3.drag()
    //                 .on('start', drag_start)
    //                 .on('drag', drag_drag)

    // function drag_start() {
    //             start_x = +d3.event.x
    //             start_y = +d3.event.y
    //         }

    // function drag_drag(d) {
    //             d3.select(this)
    //               .attr('cx', d.x = d3.event.x).attr('cy', d.y = d3.event.y)
    //         }

    // drag_handler(dots)

    // dots.on('click', function() {
    //   let centroid = d3.select(this);
    //   let x = (centroid[0] / width) * 100;
    //   let y = (centroid[1] / height) * 100;

    //   centroid
    //       .attr("cx", x)
    //       .attr("cy", y)
    // })
    // // END EDITING CENTROIDS

    const countryDict = FuzzySet([], false);
    countries.filter(function(d) { return d3.select(this).classed("country--active")})
      .each(x => countryDict.add(x.properties.NAME_LONG))

    countries.on('click', function() {
      let country = d3.select(this);
      if (country.classed('country--active') === false) {
        resetCountries();
        return;
      }

      resetCountries();
      // Deal with currently active
      country.classed('tooltip--active', true);
      country.raise();
      missingDots.raise();
      country.transition().attr('transform', 'translate(0,-5)');
      // country.style('filter', 'url(#drop-shadow)');

      positionTooltip();
      emptySearchBox();
    })


    d3.select('.js-country-search').on('keydown', function() {
      if (d3.event.key === 'Enter') {
        let topResult = d3.select('.global-map-search__result-box').select('.global-map-search__result');
        if (topResult.nodes().length > 0) { zoomToCountry(topResult.datum()); }
        emptySearchBox();
      }
    })
    d3.select('.js-country-search').on('input', function() {
      let nearest = countryDict.get(this.value);
      let results = d3.select('.global-map-search__result-box').selectAll('.global-map-search__result');
      if (nearest === null) {
        emptySearchBox();
        return;
      };
      d3.select(this).classed('global-map__searchbox--open', true)
      results = results
          .data(nearest, d => d[1])
      results.exit().remove();
      results.enter().append('div')
          .classed('global-map-search__result', true)
          .text(d => d[1])
        .merge(results)
          .order()
        .on('click', zoomToCountry)
    });

    zoomRect.raise();

    function zoomToCountry(countryMatch) {
      emptySearchBox();
      let bounds;
      d3.selectAll('.map__country').classed('tooltip--active', false)
      let country = countries.filter(x => x.properties.NAME_LONG == countryMatch[1])
                .classed('tooltip--active', true);
      let d = country.data()[0];
      if (d.properties.BOUNDING_BOX) {
        bounds = d.properties.BOUNDING_BOX.map(projection);
      } else {
        bounds = path.bounds(d);
      }
      let dx = bounds[1][0] - bounds[0][0],
          dy = bounds[1][1] - bounds[0][1],
          x = (bounds[0][0] + bounds[1][0]) / 2,
          y = (bounds[0][1] + bounds[1][1]) / 2;
      let k = .75 / Math.max(dx / width, dy / height);
      k = k > 16 ? 16 : k;
      let translate = [width / 2 - k * x, height / 2 - k * y];


      zoom.transform(zoomRect.transition().duration(2000).ease(d3.easeQuadInOut),
        d3.zoomIdentity.translate(translate[0], translate[1]).scale(k))
      positionTooltip();
    }

    d3.select('.zoom-controls').raise();
    d3.selectAll('.js-zoom').on('click', function() {
      function translate(transform, p0, p1) {
        const x = p0[0] - p1[0] * transform.k;
        const y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : d3.zoomIdentity.translate(x, y).scale(transform.k)
      }
      const [minZoom, maxZoom] = zoom.scaleExtent();
      const zoomDir = d3.select(this).classed('js-zoom--out') ? 'out' : 'in';
      const t = d3.zoomTransform(zoomRect.node());

      if (zoomDir === 'in' && t.k >= maxZoom) return;
      if (zoomDir === 'out' && t.k <= minZoom) return;
      let scaleFactor = zoomDir === 'out' ? 0.5 : 2
      let nextZoom = t.k * scaleFactor;
      if (nextZoom <= minZoom) {
        scaleFactor = 1 / t.k;
      }
      if (nextZoom >= maxZoom) {
        scaleFactor = maxZoom / nextZoom;
      }

      const zoomedT = t.scale(scaleFactor);
      const p = [width/2, height/2];
      const invertedP = t.invert(p);
      
      const newTransform = translate(zoomedT, p, invertedP);
      zoom.transform(zoomRect, newTransform)
    })
    
    zoomRect.on('click', function() {
      zoomRect.style('pointer-events', 'none');
      const country = d3.select(document.elementFromPoint(d3.event.x, d3.event.y));
      zoomRect.style('pointer-events', 'all');
      if (country.classed('country--active') === false) {
        resetCountries();
        return;
      }

      resetCountries();
      // Deal with currently active
      country.classed('tooltip--active', true);
      country.raise();
      missingDots.raise();
      country.transition().attr('transform', 'translate(0,-5)');
      // country.style('filter', 'url(#drop-shadow)');

      positionTooltip();
      emptySearchBox();
    })

    tooltip.on('click', function(d) {
      let entry = entries.find(x => d.ISO_A2.toLowerCase() === x.code);
      document.location.href = entry.url
    })

    backdrop.on('click', function() {
      // console.info()
      tooltip.style('display', 'none');
      resetCountries();
    })

    function toggleTooltip() {
      tooltip.style('display') == 'none' ? tooltip.style('display', 'block') : tooltip.style('display', 'none')
    }

    function resetCountries() {
      tooltip.style('display', 'none');
      // Zero out last active
      let countries = d3.selectAll('.map__country');
      countries.classed('tooltip--active', false);
      countries.transition().attr('transform', 'translate(0,0)');
      countries.style('filter', null);
    }
  }); // end of promise

  function translate(transform, p0, p1) {
    const x = p0[0] - p1[0] * transform.k;
    const y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : d3.zoomIdentity.translate(x, y).scale(transform.k)
  }

  function emptySearchBox() {
    let searchBox = d3.select('.js-country-search')
    d3.select('.global-map-search__result-box')
      .selectAll('.global-map-search__result')
        .data([])
      .exit().remove();

    searchBox
        .classed('global-map__searchbox--open', false)
        .attr('value', '')
  }

  function positionTooltip() {
    const country = d3.select('.tooltip--active')
    if (country.nodes().length == 0) return;

    let attributes = country.datum().properties;
    tooltipCountryName.text(function(d) {
      return attributes.NAME_LONG;
    })
    tooltip.datum(attributes);
    const t = d3.zoomTransform(zoomRect.node());
    xAxis.range([0 - t.x, width - t.x]);
    yAxis.range([0 - t.y, height - t.y]);
    // TODO: Why not pop up the tooltip wherever they happened to click?
    // We know which country it is based on the click event. Currently,
    // if you zoom into French Suriname and click, the tooltip will pop
    // up back on the Continent.
    let lat = country.datum().properties.LAT;
    let long = country.datum().properties.LONG;
    let centroid = projection([long, lat]).map(x => x * t.k);
    let centroidPct = [
      xAxis.invert(centroid[0]) * 100,
      yAxis.invert(centroid[1]) * 100
    ]

    let x = centroidPct[0]
    let y = centroidPct[1]

    tooltip.style('display', 'block');
    tooltip
        .style('left', `${x}%`)
        .style('right', 'auto')
        .style('bottom', `${100 - y}%`)
        .style('top', 'auto');

    placard
        .classed('top', false)
        .classed('right', false);


    let placardDims = {
      width: placard.node().offsetWidth,
      height: placard.node().offsetHeight,
    };

    let svgDims = {
      width: svg.node().clientWidth,
      height: svg.node().clientHeight,
    };

    let safeY = placardDims.height * 1.05;
    let safeX = svgDims.width - (placardDims.width + (svgDims.width * 0.05));

    // top and right side have buffers that equal to width of tooltip / height of tooltip + 50px change.
    // Check offset of centroid to see if we're within that
    if (svgDims.width * (x / 100) > safeX) {
        tooltip.style('right', `${100 - x}%`);
        tooltip.style('left', 'auto');
        placard.classed('right', true);
    }
    if (svgDims.height * (y / 100) < safeY) {
      placard.classed('top', true);
      tooltip.style('top', `${y}%`);
      tooltip.style('bottom', 'auto');
    }
  }
}
renderMap();
